import { useState } from 'react';
import Icon from './Icon';
import { SERVICES, SITE } from '../data';

const INFO = [
  { icon: 'mail', label: 'Email us', value: SITE.email, href: `mailto:${SITE.email}` },
  { icon: 'phone', label: 'Call us', value: SITE.phone, href: `tel:${SITE.phone.replace(/[^+\d]/g, '')}` },
  { icon: 'pin', label: 'Location', value: SITE.address },
  { icon: 'clock', label: 'Working hours', value: SITE.hours },
];

const field = 'w-full rounded-xl border border-brand/15 bg-white px-4 py-3 text-sm text-ink outline-none transition-colors placeholder:text-slate-400 focus:border-brand focus:ring-4 focus:ring-brand/10';

export default function Contact({ defaultService }) {
  const [status, setStatus] = useState({ state: 'idle', error: '' });

  // Saves the enquiry to the MySQL database through /api/contact.php (see database.sql).
  const submit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const d = Object.fromEntries(new FormData(form));
    setStatus({ state: 'sending', error: '' });
    try {
      const res = await fetch('/api/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(d),
      });
      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json.error || 'Something went wrong.');
      form.reset();
      setStatus({ state: 'sent', error: '' });
    } catch (err) {
      setStatus({ state: 'error', error: err.message });
    }
  };

  return (
    <div className="overflow-hidden rounded-[2rem] bg-white shadow-2xl ring-1 ring-brand/10">
      <div className="grid lg:grid-cols-[.85fr_1.15fr]">
        <div className="relative overflow-hidden bg-gradient-to-br from-brand to-ink p-8 text-white sm:p-12" data-anim="left">
          <div className="grid-bg pointer-events-none absolute inset-0 opacity-60" />
          <div className="relative">
            <span className="eyebrow eyebrow-dark">Contact details</span>
            <h2 className="h2 mt-5">Let’s build <span className="text-accent">something</span> <span className="text-outline">great</span> together</h2>
            <p className="mt-4 text-white/70">Tell us about your project and we will send a free proposal and estimate within one business day.</p>
            <ul className="mt-9 space-y-6">
              {INFO.map((c) => (
                <li key={c.label} className="flex items-center gap-4">
                  <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand-lime/15 text-brand-lime"><Icon name={c.icon} /></span>
                  <span>
                    <span className="block text-xs uppercase tracking-wider text-white/50">{c.label}</span>
                    {c.href ? <a href={c.href} className="font-medium hover:text-brand-lime">{c.value}</a> : <span className="font-medium">{c.value}</span>}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-5 p-8 sm:p-12" data-anim="right">
          <div className="grid gap-5 sm:grid-cols-2">
            <label className="text-sm font-medium text-ink">Full name
              <input name="name" required className={`${field} mt-2`} placeholder="Jane Smith" autoComplete="name" />
            </label>
            <label className="text-sm font-medium text-ink">Email address
              <input name="email" type="email" required className={`${field} mt-2`} placeholder="you@company.com" autoComplete="email" />
            </label>
          </div>
          <label className="block text-sm font-medium text-ink">Service you need
            <select name="service" className={`${field} mt-2`} defaultValue={defaultService || SERVICES[0].title}>
              {SERVICES.map((s) => <option key={s.slug}>{s.title}</option>)}
              <option>Something else</option>
            </select>
          </label>
          <label className="block text-sm font-medium text-ink">Project details
            <textarea name="message" required rows={5} className={`${field} mt-2 resize-none`} placeholder="Tell us about your goals, timeline and budget…" />
          </label>
          <button type="submit" disabled={status.state === 'sending'} className="btn-green w-full sm:w-auto">{status.state === 'sending' ? 'Sending…' : 'Send message'} <Icon name="arrow" className="h-4 w-4" /></button>
          {status.state === 'sent' && <p className="text-sm font-medium text-brand" role="status">Thanks! Your message has been received. We will reply within one business day.</p>}
          {status.state === 'error' && <p className="text-sm font-medium text-red-600" role="alert">{status.error}</p>}
        </form>
      </div>
    </div>
  );
}
